module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vrepr6-8794894889812aef6b230cb51bbef98f.jpg";